module.exports = __webpack_public_path__ + "static/media/1_A1_05.a0f10abd.png";